import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {Component} from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import firebase from 'firebase/app';
import 'firebase/database';
import { NavLink } from 'react-router-dom';
import ReactTooltip from "react-tooltip";


export default class UploadWaterView extends Component {
  constructor(props){
    super(props);
    this.state = {
      amount: "",
      usage: "",
      month: "",

      errorMessage: '',
      disabled: false,
      success: null,
    }
  }

  isValidDate(dateString) {
    // First check for the pattern
    if(!/^\d{1,2}-\d{4}$/.test(dateString)){
      return false;
    }

    // Parse the date parts to integers
    var parts = dateString.split("/");
    console.log(parts)
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[1], 10);

    // Check the ranges of month and year
    if(year < 1000 || year > 3000 || month === 0 || month > 12){
      return false;
    }
    return true;
  }


  handleChange = (event) => {
    let name = event.target.name;
    let newValue = event.target.value;
    this.setState( {[name]: newValue, disabled: false, success: null} );
  }

  getMissingField = () => {
    let allFields = {
      usage: this.state.usage, 
      amount: this.state.amount, 
      month: this.state.month,
      billType: "gas", 
    };

    let missing = [];
    Object.keys(allFields).map( (key) => {
      if (allFields[key] === ""){
        missing.push(key);
      }
      return key;
    });
    return missing;
  }

  positiveNumCheck(number) {
    if (number > 0) {
      return true
    }
    return false;
  }
 
  billRef = firebase.database().ref("bills");

  handleSubmit = (event) => {
    event.preventDefault();
    
    let missingField = this.getMissingField();
    let monthCheck = this.isValidDate(this.state.month);
    let positiveUsage = this.positiveNumCheck(this.state.usage);
    let positiveAmount = this.positiveNumCheck(this.state.amount);
    let error = '';

    let fieldStr = 'field';
    if(missingField.length > 1){
      fieldStr = 'fields';
    }

    if (missingField.length > 0){
      let missingStr = missingField.toString().replace(/,/g, ', ').replace(/,([^,]*)$/,', and$1');
      error = <p className="alert alert-danger"><strong>Please fill in the {missingStr} {fieldStr}.</strong></p>;
      this.setState( {errorMessage: error, disabled: true} );
    } else if (!monthCheck) {
        error = <p className="alert alert-danger"><strong>Please check that you entered valid numbers for the month and year and used MM/YYYY format</strong></p>;
        this.setState( {errorMessage: error, disabled: true} );
    } else if (!positiveUsage || !positiveAmount) {
        if (!positiveAmount && !positiveUsage) {
          error = <p className="alert alert-danger"><strong>Must enter a positive number for Amount and Usage</strong></p>;
          this.setState( {errorMessage: error, disabled: true} );
        } else if(!positiveAmount) {
          error = <p className="alert alert-danger"><strong>Must enter a positive number for Amount</strong></p>;
          this.setState( {errorMessage: error, disabled: true} );
        } else if (!positiveUsage) {
          error = <p className="alert alert-danger"><strong>Must enter a positive number for Usage</strong></p>;
          this.setState( {errorMessage: error, disabled: true} );
        }
    } else {
      let userKey = this.props.user.email.replace(/[^a-zA-Z0-9]/g, "");
      firebase.database().ref('userBills').child(userKey).child('gas').child(this.state.month).set({
        amount: this.state.amount,
        usage: this.state.usage,
        month: this.state.month,
        billType: "gas",
      });
      this.props.history.push("/home");
    }
  };

    

  

  componentWillUnmount(){
    this.billRef.off();
  }




  render(){
    return (
    <div className="container">
      <NavLink to="/input" className="previous round back-button" aria-label="Back to input">&#8249;</NavLink>
      <h1 className="input-title">Tell us about your gas bill</h1>
      <div className="upload-container">
        {/* <div className="upload-item upload-center">
          <h2>Upload your bill here</h2>
          <img className="upload" alt="upload document" src="/img/upload.png"></img>
        </div>
        <div className="upload-item">
          <h2 className="upload-center">OR</h2>
        </div> */}
        <div className="upload-item">
          <h2 className="upload-center">Type in your Data here</h2>
            <p className="upload-center">Where do I find this data? <FontAwesomeIcon data-tip data-for="where" icon={faInfoCircle}/></p>
              <ReactTooltip id="where" place="bottom" effect="float">
                <div className="upload-center">
                  <h3>Bill Example</h3>
                  <p>This is an example of a WA King County resident’s bill. Use this to see where you can find the data to fill out the form.</p>
                  <img className="example-bill" alt="example bill" src="/img/Gas1.png"></img>
                  <img className="example-bill" alt="example bill" src="/img/Gas2.png"></img>
                </div>
                
              </ReactTooltip>
              {this.state.errorMessage}
          <form>
            <label htmlFor="month">Month this bill is for</label>
            <input name="month" 
              type="text" 
              placeholder="MM-YYYY"
              value={this.state.month}
              onChange={this.handleChange}
            ></input>

            <label htmlFor="usage">Usage in Therms <FontAwesomeIcon data-tip data-for="therms" icon={faInfoCircle}/> </label>
            <ReactTooltip id="therms" place="bottom" effect="float">
              <h3>Therms Definition</h3>
              <p>Kilowatt-hours is an energy unit for electricity. This value tells you how many kilowatt-hours the vehicle would use to travel 100 miles. (merriam-webster.com)</p>
            </ReactTooltip>
            
            <input 
              type="number" 
              name="usage" 
              onChange={this.handleChange}
              value={this.state.usage}
            ></input>

            <label htmlFor="amount">US Dollars spent on bill</label>
            <input 
              type="number" 
              name="amount" 
              onChange={this.handleChange}
              value={this.state.amount} 
            ></input>
          </form>
        </div>

      
      </div>
      <NavLink aria-label="button" className="input-button" to="/home" onClick={this.handleSubmit} disabled={this.state.disabled}>Submit</NavLink>
      
    </div>
    )
  }
}